<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <h4 class="card-title" v-translate>Attachments</h4>
        </div>
        <div class="col-md-6 text-right">
          <a v-if="canEdit" href="" class="btn btn-success" @click.prevent="addEntry"><i class="nc-icon nc-simple-add"></i>&nbsp;<span v-translate>Add attachment</span></a>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="table-responsive">
        <el-table class="table-attachments"
                  style="width: 100%"
                  ref="table"
                  :data="tableData">
          <el-table-column min-width="120" max-width="160">
            <template slot-scope="props">
              <div class="img-container" v-if="props.row.fileUrl && !props.row.fileUrl.endsWith('.pdf')">
                <img :src="props.row.fileUrl" :alt="props.row.name" class="img img-responsive">
              </div>
              <div class="text-center" v-else-if="props.row.fileUrl.endsWith('.pdf')">
                <i class="fa fa-file-pdf-o fa-4x" aria-hidden="true"></i>
                <br/>
                <a :href="props.row.fileUrl" download><translate>Download</translate></a>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="150" :label="'Name' | translate">
            <template slot-scope="props">
              <strong>{{props.row.name}}</strong>
              <p>{{getType(props.row.type)}}</p>
              <p><strong v-translate>Visits:</strong> {{ props.row.visits || 0 }}</p>
              <p><strong v-translate>Interested:</strong> {{ props.row.interested || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column
            class-name="action-buttons td-actions"
            align="right"
            v-if="canEdit"
            :label="'Actions' | translate">
            <template slot-scope="props">
              <el-tooltip :content="'Edit' | translate" placement="top">
                <p-button type="success" size="sm" icon @click="(e) => handleEdit(e, props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
              </el-tooltip>
              <el-tooltip :content="'Delete' | translate" placement="top">
                <p-button type="danger" size="sm" icon @click="(e) => handleDelete(e, props.$index, props.row)">
                  <i class="fa fa-times"></i>
                </p-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <modal :show.sync="formModal.show" modal-classes="modal-fullwidth">
      <edit-form v-model="formModal" is-modal :material-id="materialId"
                     v-on="$listeners" @reload-content="reloadContent"></edit-form>
    </modal>
  </div>
</template>
<script>
  import {Table, TableColumn, Tooltip} from 'element-ui'
  import {Modal} from 'src/components/UIComponents'
  import EditForm from '../AttachmentsForm'
  import swal from 'sweetalert2'


  export default {
    components: {
      Modal,
      EditForm,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tooltip.name]: Tooltip
    },
    computed: {
      canEdit () {
        return this.$auth.user().isSuperuser || this.$root.expoStatPermissions.stands[this.$route.params.standId]
      },
      tableData () {
        return this.model
      }
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      materialId: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        model: _.cloneDeep(this.value),
        formModal: {
          show: false,
          modelId: null
        }
      }
    },
    methods: {
      getType (type) {
        switch (type) {
          case 'image':
            return 'Изображение'
          case 'pdf':
            return 'PDF'
          case 'video':
            return 'Видео'
        }
      },
      addEntry () {
        this.formModal.modelId = null
        this.formModal.show = true
      },
      handleEdit(e, index,row) {
        this.formModal.modelId = row.id
        this.formModal.show = true
      },
      handleDelete (event, index, row) {
        const vm = this
        event.stopPropagation()
        let message = this.$gettext('<span>Do you really want to remove the attachment <strong>%{name}</strong>?</span></br><span>It will be impossible to recover information!</span>')
        swal({
          title: this.$gettext('Are you sure?'),
          html: this.$gettextInterpolate(message, {name: row.name}),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$gettext('Yes, delete it!'),
          cancelButtonText: this.$gettext('No, keep it'),
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function () {
          vm.$http.delete(`stands/stand/${vm.$route.params.standId}/materials/${vm.materialId}/attachments/${row.id}/`).then(result => {
            let message = vm.$gettext('<span>Attachment <strong>%{name}</strong> successfully deleted.</span>')
            swal({
              title: vm.$gettext('Successful delete'),
              html: vm.$gettextInterpolate(message, {name: row.name}),
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
            vm.reloadContent()
            vm.$emit('reload-content')
          }).catch(error => {
            let message = vm.$gettext('<span>Failed to delete attachment <strong>%{name}</strong><br>Status: %{statusCode}<br>Message: <code>%{details}</code></span>')
            let statusCode = error.response.status
            let details = ''
            if (error.response.data && error.response.data.detail) {
              details = error.response.data.detail
            }
            swal({
              title: vm.$gettext('Error'),
              html: vm.$gettextInterpolate(message, {name: row.name, statusCode, details}),
              type: 'error',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          // if (dismiss === 'cancel') {
          //   swal({
          //     title: 'Cancelled',
          //     text: 'Your imaginary file is safe :)',
          //     type: 'error',
          //     confirmButtonClass: 'btn btn-info btn-fill',
          //     buttonsStyling: false
          //   })
          // }
        })
      },

      async reloadContent () {
        this.$emit('reload-content')
        // const result = this.$http.get(`/stands/${this.$route.params.standId}/materials/${this.materialId}/attachments/`)
        // this.model = result.data
        // debugger
        // this.$refs.table
      },

      selectMaterial (row) {},
      updateProfile () {
        alert('Your data: ' + JSON.stringify(this.user))
      }
    }
  }

</script>
<style>
  .el-table__row .cell p {
    margin-bottom: 0;
  }
</style>
